import React from 'react';

import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import { IActivity } from '@src/model/activity/Activity';
import { ActivityPhaseEnum } from '@src/model/activity/ActivityPhase';
import { ActivityUtils } from '@src/service/util/activity/ActivityUtils';
import { Tag } from 'antd';


// -- Prop types
// ----------

export interface IExamInstanceStatusOwnProps {
  activity: IActivity;
}
type IExamInstanceStatusProps = IExamInstanceStatusOwnProps & IWithLocalizeOwnProps;


// -- Component
// ----------

/** Describe your component ... */
const ExamInstanceStatus: React.FC<IExamInstanceStatusProps> = (props: IExamInstanceStatusProps) => {
  let tagColor;
  if (props.activity.currentPhase.id === ActivityPhaseEnum.EVALUATED) {
    tagColor = 'green';
  } else if (props.activity.currentPhase.id === ActivityPhaseEnum.ANSWERS_SUBMITTED) {
    tagColor = 'yellow';
  }
  else if (props.activity.currentPhase.id === ActivityPhaseEnum.CANCELLED) {
    tagColor = 'red';
  } else {
    tagColor = 'grey';
  }
  const phaseName = ActivityUtils.getPhaseName(props.activity);

  return (
    <Tag color={tagColor}> {props.translate(`EXAM_INSTANCE.LIST_ITEM.STATUS.${phaseName}`)} </Tag>
  );
};

export default withLocalize<IExamInstanceStatusOwnProps>(ExamInstanceStatus as any);
